export default __webpack_public_path__ + "static/media/WhiteStarMobile.983cc7bf.svg";